import {
  BaselineExistingItemDto,
  baselineHttp,
  BaselinePersonalizationItemDto,
  BaselineSpecialRequestDto,
  GetBaselineArgs,
  GetBaselinePersonalizationItemArgs,
  GetBaselineSpecialRequestArgs,
} from '@/core';
import { api } from '../api';
import { rtkq, RtkqRequest } from '../rtkq';

export type BaselinePersonalizationItemState = BaselinePersonalizationItemDto;
export type BaselineExistingItemState = BaselineExistingItemDto;
export type BaselineSpecialRequestState = BaselineSpecialRequestDto;

const baselineApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBaselinePersonalizationItems: build.query<
      BaselinePersonalizationItemState[],
      RtkqRequest<GetBaselinePersonalizationItemArgs>
    >({
      queryFn: async (args) => {
        return rtkq(args).exec(() =>
          baselineHttp.getPersonalizationItems(args),
        );
      },
      providesTags: (result = []) => [
        { type: 'personalizationItem', id: 'list' },
        ...result.flatMap(({ id }) => [
          { type: 'personalizationItem' as const, id },
        ]),
      ],
    }),

    getBaselineSpecialRequests: build.query<
      BaselineSpecialRequestState[],
      RtkqRequest<GetBaselineSpecialRequestArgs>
    >({
      queryFn: async (args) => {
        return rtkq(args).exec(() => baselineHttp.getSpecialRequests(args));
      },
      providesTags: (result = []) => [
        { type: 'special-request', id: 'list' },
        ...result.flatMap(({ id }) => [
          {
            type: 'special-request' as const,
            id,
          },
          {
            type: 'special-request-price' as const,
            id,
          },
        ]),
      ],
    }),

    getBaselineExistingItems: build.query<
      BaselineExistingItemState[],
      RtkqRequest<GetBaselineArgs>
    >({
      queryFn: async (args) => {
        return await rtkq(args).exec(() => baselineHttp.getExistingItems(args));
      },
      providesTags: (result = []) => [
        { type: 'room', id: 'list' },
        { type: 'existing-item', id: 'list' },
        ...result.map(({ id }) => ({
          type: 'existing-item' as const,
          id,
        })),
      ],
    }),
  }),
});

export const {
  useGetBaselinePersonalizationItemsQuery,
  useGetBaselineSpecialRequestsQuery,
  useGetBaselineExistingItemsQuery,
} = baselineApi;
